export interface ClosedDayWebEntity {
    title: string;
    fromDate: string;
    toDate: string;
}